import emptyFolderAnimation from '@/public/lottie/empty-folder.json';
import { Typography } from 'antd';
import dynamic from 'next/dynamic';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
const { Text } = Typography;

export default function EmptyLibrary() {
   const { shared } = useContext(LibraryContext);
   return (
      <div
         style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
         }}
      >
         <Lottie animationData={emptyFolderAnimation} style={{ maxWidth: 200 }} />
         <Text style={{ fontSize: 18, fontWeight: 500, textAlign: 'center' }}>No files or folders</Text>
         <Text style={{ fontSize: 14, fontWeight: 400, color: '#8C8C8C', textAlign: 'center' }}>
            {shared ? 'No files or folders shared with you' : ''}
            {!shared ? 'Upload files to your account to get started' : ''}
         </Text>
      </div>
   );
}
